"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setInstanceGetter = exports.getAuthHeader = exports.getAuthorizationToken = void 0;
var tslib_1 = require("tslib");
var wix_sdk_1 = require("../wix-sdk");
var instanceGetter = global.Wix ? wix_sdk_1.WixSDK.Utils.getInstance : null;
var getAuthorizationToken = function () {
    var BMApi = global.BusinessManagerAPI;
    if (BMApi && Object.keys(BMApi).length) {
        return BMApi.getCurrentInstance(BMApi.appDefIds.video);
    }
    if (instanceGetter) {
        return instanceGetter();
    }
    return null;
};
exports.getAuthorizationToken = getAuthorizationToken;
var getAuthHeader = function () {
    if (global.__MEDIA_TOKEN__) {
        // Dashboard
        var headers = {
            'X-WIX-SITE-TOKEN': global.__MEDIA_TOKEN__,
        };
        if (global.BusinessManagerAPI &&
            Object.keys(global.BusinessManagerAPI).length) {
            return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, headers), { Authorization: global.BusinessManagerAPI.getCurrentInstance(global.BusinessManagerAPI.appDefIds.video) });
        }
        return headers;
    }
    var instance = instanceGetter && instanceGetter();
    if (!instance) {
        return null;
    }
    return {
        'X-WIX-INSTANCE-TOKEN': instance,
    };
};
exports.getAuthHeader = getAuthHeader;
function setInstanceGetter(_instanceGetter) {
    instanceGetter = _instanceGetter;
}
exports.setInstanceGetter = setInstanceGetter;
//# sourceMappingURL=get-auth-header.js.map